import { Info } from 'lucide-react';

/**
 * Unmissable banner for screens that are product previews not yet connected to live data. Keeps the
 * roadmap surface visible for design partners while being honest that the numbers/status shown are
 * illustrative, not live enforcement/compliance results.
 */
export function PreviewBanner({ feature }: { feature?: string }) {
  return (
    <div className="mb-4 flex items-start gap-3 rounded-lg border border-amber-400/50 bg-amber-50 px-4 py-3 text-amber-900">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <div className="text-sm">
        <span className="font-semibold">Preview. Not connected to live data.</span>{' '}
        {feature ? `${feature} is on the roadmap. ` : ''}
        The figures, statuses, and timestamps shown here are illustrative examples, not live monitoring
        or compliance results. Live governance runs through Policy Packs, Audit &amp; Logs, Approvals, and
        the Dashboard.
      </div>
    </div>
  );
}
